<script>
import IndexMixin from '@/components/Base/IndexMixin';
import MetaMixin from '@/components/Base/MetaMixin';
import AccessMixin from '@/components/Base/AccessMixin';
import UserMixin from '@/components/Base/UserMixin';
import UseProfileMixin from '@/components/Base/UseProfileMixin';
import SvcPagesMixin from '@/components/Base/SvcPagesMixin';

export default {
    name: 'base-index-page',

    mixins: [ IndexMixin, MetaMixin, AccessMixin, UserMixin, UseProfileMixin, SvcPagesMixin ],

    metaInfo: function () {
        return this.getMetaInfo(this.pageMetaInfo, this.$route);
    },

    data: function () {
        return {
            pageMetaInfo: {}, // default vue-meta data
            initialRender: true, // later rendered from keep-alive memory
            isDeactivated: false, // is somewhere in keep-alive memory but not in view
            debouncedPageAccessCheck: _.debounce(this.onPageAccessCheck, 500, {trailing: true}),
            promotionPageReached: false // eg. end of anonymous scroll or (+) pages
        };
    },

    /**
     * Activate index page.
     * Triggers also when returning to already rendered page in keep-alive memory.
     * Sometimes the page might not be rendered correctly.
     */
    activated: function () {
        if (!this.initialRender) {
            this.$nextTick(() => {
                this.$eventBus.$emit('slides-reset');
            });
        }
        this.initialRender = false;
        this.isDeactivated = false;
        this.$eventBus.$on('page-access-check', this.debouncedPageAccessCheck);
        this.$eventBus.$on('entity-reload', this.onEntityReload);
    },

    deactivated: function () {
        this.isDeactivated = true;
        this.error = null;
        this.$eventBus.$off('page-access-check', this.debouncedPageAccessCheck);
        this.$eventBus.$off('entity-reload', this.onEntityReload);
    },

    methods: {
        /**
         * Calculate limit for pageIndex (next page + 1) which will not be loaded if limit exceeds.
         * Requires UserMixin for `membershipLevel`.
         *
         * PageIndex 0 was initially loaded. This fn was called, and
         * PageIndex 1 was just loaded. Minimum limit is 1 (= 2 pages), which would set `promotionPageReached`.
         *
         *      PageIndex   items loaded with pageSize 10
         *          0       10
         *          1       20
         *
         *      pageLimit   items loaded, with pageSize 10
         *          1       20
         *          2       30
         *          3       40
         */
        isPromotionPageReached: function (pageLimit, pageIndex, belowMembershipLevel) {
            // if anonymous, and limit is reached, return true
            return (this.membershipLevel < belowMembershipLevel && pageIndex >= pageLimit);
        },

        /**
         * Disable edit mode, emit signal to hide edit toggle in navbar.
         */
        onPageAccessCheck: function () {
            this.$eventBus.$emit('page-access-change', false, null, true);
        },

        onEntityReload: function (locale) {
            // this.getSvcPages && this.getSvcPages();
        }
    }
};
</script>
